package uk.co.nickthecoder.glok.backend.webgl

import kotlinx.browser.window
import org.w3c.dom.Image
import org.w3c.xhr.XMLHttpRequest
import uk.co.nickthecoder.glok.backend.Resources
import uk.co.nickthecoder.glok.backend.Texture
import uk.co.nickthecoder.glok.util.log


/**
 * Loads textures from files.
 */
internal class WebGLResources(val path: String) : Resources {

    override fun loadTexture(name: String): Texture {

        val fullPath = if (path.isEmpty()) path else "$path/$name"
        return DelayedTexture(name, fullPath)
    }

    override fun loadText(name: String, onLoaded: (String) -> Unit) {
        val fullPath = if (path.isEmpty()) path else "$path/$name"

        val xmlHttp = XMLHttpRequest()
        xmlHttp.onload = {
            if (xmlHttp.readyState == 4.toShort() && xmlHttp.status == 200.toShort()) {
                onLoaded(xmlHttp.responseText)
            } else {
                log.error("Load failed : readyState : ${xmlHttp.readyState} status : ${xmlHttp.status}")
            }
        }
        xmlHttp.open("GET", fullPath, true)
        xmlHttp.send()

    }

}

/**
 * Creates textures from html <img> elements.
 */
internal class PreLoadedResources(val path: String) : Resources {

    override fun loadTexture(name: String): Texture {
        val fullPath = "$path/$name"
        val image = window.document.getElementById(fullPath) as? Image
        return if (image == null) {
            dummyTexture
        } else {
            LoadedWebGLTexture(name, image)
        }
    }

    override fun loadText(name: String, onLoaded: (String) -> Unit) {
        throw NotImplementedError("Text is never pre-loaded")
    }

    companion object {
        val dummyTexture: LoadedWebGLTexture by lazy {
            LoadedWebGLTexture("dummy texture")
        }
    }
}
